import { Component, Input } from '@angular/core';

@Component({
  selector: 'slotcom-h2',
  templateUrl: './h2.component.html',
  styleUrls: ['./h2.component.scss'],
  standalone: true,
})
export class Heading2Component {
  @Input() text: string;
  @Input() bold: boolean;
}
